module.exports = __webpack_public_path__ + "img/warning.5ffa0a60.svg";